import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

/**
 * @param {{
 *    className?: string
 *    noPadding?: boolean
 * }} props
 * @returns {React.Component}
 */
const PortletBody = ({ className, noPadding, ...props }) => {
  return (
    <div
      {...props}
      className={clsx(
        'zr-portlet__body kt-portlet__body',
        {
          'no-padding': noPadding
        },
        className
      )}
    />
  )
}

PortletBody.propTypes = {
  className: PropTypes.string,
  noPadding: PropTypes.bool
}

export default PortletBody
